import { Form, Input, Select } from "antd";

export const CreateUserForm = ({ form, roles = [], onFinish }) => {
  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Form.Item
        label="Ім'я"
        name="name"
        rules={[
          { required: true, message: "Введіть ім'я користувача" },
          { min: 6, message: "Мінімум 6 символів" },
        ]}
      >
        <Input placeholder="Наприклад: Сидоренко Тетяна" />
      </Form.Item>

      <Form.Item
        label="Пароль"
        name="password"
        normalize={(value) => value?.trim()}
        rules={[
          { required: true, message: "Введіть пароль" },
          { min: 10, message: "Мінімум 10 символів" },
        ]}
      >
        <Input.Password placeholder="Введіть пароль" />
      </Form.Item>

      <Form.Item
        label="Email"
        name="email"
        normalize={(value) => value?.trim().toLowerCase()}
        rules={[
          { required: true, message: "Введіть email" },
          { type: "email", message: "Некоректний email" },
        ]}
      >
        <Input placeholder="example@gmail.com" />
      </Form.Item>

      <Form.Item label="Доступи" name="roles">
        <Select
          mode="multiple"
          placeholder="Оберіть ролі"
          allowClear
          options={roles.map((r) => ({
            label: r.role,
            value: r.id,
          }))}
        />
      </Form.Item>
    </Form>
  );
};
